document.addEventListener('DOMContentLoaded', function() {
  BOLD.common.eventEmitter.on('BOLD_OPTIONS_option_products_loaded', function(event) {

const targets = document.querySelectorAll('.bold_option_title');
targets.forEach((target) =>{
  if (target.textContent.includes('Size')){
    target.nextElementSibling.style.marginBottom = "50px";
    const swatches = target.parentElement.querySelectorAll('.bold_option_value_swatch');
    swatches.forEach((swatch) =>{
      swatch.style.height = '100px';
      swatch.style.width = '100px';
    })
  }
})

const prices = document.querySelectorAll('.bold_option_value_price');
prices.forEach((price) =>{
  const text = price.textContent;
  price.textContent = '+' + text;
})
})})
